export const COMMUNITY_MEMBERS_RESOURCE = 'communityMembers';
export const CREATE_COMMUNITY_MEMBER_RESOURCE = 'createCommunityMember';
export const COMMUNITY_MEMBERS_PAGESIZE = 25;

export const CREATE_PRINCIPAL_RESOURCE = 'createPrincipal';

export const COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE = 'communityOnboardingTemplates';
export const COMMUNITY_ONBOARDING_TEMPLATE_RESOURCE = 'communityOnboardingTemplate';
